import type { IFilesSelectorProps } from '@components/FilesSelector/FilesSelector';
import { FilesSelector } from '@components/FilesSelector/FilesSelector';

import type React from 'react';
import type { Control } from 'react-hook-form';
import { useController } from 'react-hook-form';
import type { UseControllerProps } from 'react-hook-form/dist/types/controller';

interface IFilesSelectorFormWrapperProps extends IFilesSelectorProps {
    name?: string;
    control?: Control<any, any>;
    rules?: UseControllerProps['rules'];
    classNameWrapper?: string;
}

export const FileSelectorFormWrapper: React.FC<Omit<IFilesSelectorFormWrapperProps, 'fieldState'>> = (props) => {
    const { name = '', control, rules, classNameWrapper } = props;
    const { fieldState } = useController({
        name,
        control,
        rules,
    });

    return (
        <div className={classNameWrapper}>
            <FilesSelector fieldState={fieldState} {...props} />
        </div>
    );
};

FileSelectorFormWrapper.displayName = 'FileSelectorFormWrapper';
